import { ReactComponent as DashboardIcon } from "../assets/icons/Sidebar/dashboard.svg";
import { ReactComponent as GetStartedIcon } from "../assets/icons/Sidebar/get-started.svg";
import { ReactComponent as AccountMetricsIcons } from "../assets/icons/Sidebar/account-metrics.svg";
import { ReactComponent as PaymentIcon } from "../assets/icons/Sidebar/Payment.svg";
import { ReactComponent as TradeMateIcon } from "../assets/icons/Sidebar/TradeMate.svg";
import { ReactComponent as LeaderboardIcon } from "../assets/icons/Sidebar/Leaderboard.svg";
import { ReactComponent as AffiliateMarketingIcon } from "../assets/icons/Sidebar/AffiliateMarketing.svg";
import { ReactComponent as FundingEvalIcon } from "../assets/icons/Sidebar/FundingEval.svg";
import { ReactComponent as PayoutAchievementIcon } from "../assets/icons/Sidebar/PayoutAchievement.svg";
import { ReactComponent as LogoutIcon } from "../assets/icons/Sidebar/Logout.svg";
import { ReactComponent as SettingsIcon } from "../assets/icons/Sidebar/Settings.svg";

const sidebarMenu = [
  {
    label: "Dashboard",
    icon: <DashboardIcon />,
    url: "/dashboard",
  },
  {
    label: "Get Started",
    icon: <GetStartedIcon />,
    url: "/getting-started",
  },
  {
    label: "Account Metrics",
    icon: <AccountMetricsIcons />,
    url: "/AccountMetric",
  },
  {
    label: "Trading Assessments",
    icon: <FundingEvalIcon />,
    url: "/FundingEvaluationPayments/89",
  },
  {
    label: "Payout & Achievements",
    icon: <PayoutAchievementIcon />,
    url: "/payoutAchievements",
  },
  {
    label: "Payment History",
    icon: <PaymentIcon />,
    url: "/PaymentHistory",
  },
  {
    label: "Competition",
    icon: <LeaderboardIcon />,
    url: "/competitionlist",
  },
  {
    label: "Trademate",
    icon: <TradeMateIcon />,
    url: "/Trademate",
  },
  {
    label: "Affiliate Marketing",
    icon: <AffiliateMarketingIcon />,
    url: "/affiliateMarketing",
  },
  {
    label: "Profile",
    icon: <SettingsIcon />,
    url: "/profile",
  },
  {
    label: "Logout",
    icon: <LogoutIcon />,
    url: "/logout",
  },
];

export default sidebarMenu;
